import React, { Fragment} from 'react'
import styled from 'styled-components/macro'

import { FormattedMessage, FormattedNumber, FormattedDate } from '@dragonraider5/react-intl'
import { Link } from 'react-router-dom'
import ArrowLink from '../../../components/ArrowLink'
import { SectionWrapper, SectionTitle } from '../../../components/Section'
import FormInfo from '../../../components/FormFields/FormInfo'
import { AddButton } from '../../../components/FormFields/FieldList'
import { ReactComponent as AddIcon } from '../../../components/Icons/add-document-icon.svg'
import { TableList, TableRow, TableCell } from '../../../components/TableList'
import ModalController from '../../../components/Modal/ModalController'
import { getApplyStepPath } from '../../MainRoutes/utils'
import { stepStatuses } from '../constants'
import statusMessages from './statusMessages'
import valueMessages from '../Steps/Project/Forms/valueMessages'
import NewApplicationModal from '../NewApplication'

const ExtraRow = styled.tr`
  ${TableCell} {
    padding-top: 0;
    font-size: .9em;
    &:first-child {
      padding-left: 32px;
      position: relative;

      &::before {
        content: '-';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 18px;
        padding-left: 2px;
        border-left: 1px solid;
      }
    }
  }
`

function ApplicationsList({ applications }) {
  return (
    <SectionWrapper>
      <SectionTitle>Mis solicitudes</SectionTitle>
      <FormInfo>Aquí puedes ver el listado de las últimas solicitudes que has comenzado y continuar con el proceso de aquellas que no hayas terminado de cumplimentar.</FormInfo>
      <TableList>
        <thead>
          <TableRow>
            <TableCell as='th' vAlign='bottom'>Producto</TableCell>
            <TableCell as='th' vAlign='bottom' align='right'>Financiación</TableCell>
            <TableCell as='th' vAlign='bottom' align='center'>Estado</TableCell>
            <TableCell as='th' vAlign='bottom' align='center'>Última actualización</TableCell>
            <TableCell as='th' vAlign='bottom'></TableCell>
          </TableRow>
        </thead>
        <tbody>
          {applications.map(apply => (
            <Fragment key={apply.id}>
              <TableRow>
                <TableCell expanded={apply.solicitude && apply.solicitude.extra.length > 0}>
                  {apply.solicitude ? (
                    <FormattedMessage
                      {...valueMessages[`financialTypes${apply.solicitude.finnancial_type}`]}
                    />
                  ) : 'ND'
                  }
                </TableCell>
                <TableCell align='right' expanded={apply.solicitude && apply.solicitude.extra.length > 0}>
                  {apply.solicitude ? (
                    <FormattedNumber
                      value={apply.solicitude.how_much}
                      format='currency'
                    />
                  ) : 'ND'}
                </TableCell>
                <TableCell align='center' rowSpan={apply.solicitude && apply.solicitude.extra.length + 1}>
                  <FormattedMessage
                    {...statusMessages[apply.status]}
                  />
                </TableCell>
                <TableCell align='center' rowSpan={apply.solicitude && apply.solicitude.extra.length + 1}>
                  <FormattedDate
                    value={apply.updated_at}
                    format="numeric"
                  />
                </TableCell>
                <TableCell rowSpan={apply.solicitude && apply.solicitude.extra.length + 1}>
                  {apply.status < stepStatuses.FINISHED && (
                    <ArrowLink
                      as={Link}
                      to={getApplyStepPath(apply)}
                    >
                      Continuar
                    </ArrowLink>
                  )}
                </TableCell>
              </TableRow>
                {apply.solicitude && apply.solicitude.extra.map((extra, idx) => (
                  <ExtraRow key={`${apply.id}-${extra.id}`}>
                    <TableCell expanded={apply.solicitude.extra.length !== idx + 1}>
                      <FormattedMessage
                        {...valueMessages[`financialTypes${extra.finnancial_type}`]}
                      />
                    </TableCell>
                    <TableCell align='right' expanded={apply.solicitude.extra.length !== idx + 1}>
                      <FormattedNumber
                        value={extra.how_much}
                        format='currency'
                      />
                    </TableCell>
                  </ExtraRow>
                ))}
            </Fragment>
          ))}
          {applications.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} align='center'>
                <em>No tienes solicitudes en proceso en este momento.</em>
              </TableCell>
            </TableRow>
          )}
        </tbody>
      </TableList>
      <ModalController>
        {({ opened, showModal, hideModal }) => (
          <Fragment>
            <AddButton onClick={showModal}>
              Necesito nueva financiación <AddIcon />
            </AddButton>
            {opened && (
              <NewApplicationModal
                handleClose={hideModal}
              />
            )}
          </Fragment>
        )}
      </ModalController>
    </SectionWrapper>
  )
}

export default ApplicationsList
